var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasicPackagePrices',{attrs:{"productNumber":_vm.productNumber,"userEditRight":_vm.userEditRight}})
}
var staticRenderFns = []

export { render, staticRenderFns }